import React from 'react';

const Terms: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif',
      padding: '2rem 0'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        <h1 style={{
          fontSize: '1.5rem',
          fontWeight: '700',
          color: '#111827',
          textAlign: 'center',
          marginBottom: '2rem',
          fontFamily: '"Playfair Display", "Georgia", serif'
        }}>
          KULLANICI SÖZLEŞMESİ VE KİRALAMA ŞARTLARI
        </h1>

        <div style={{
          fontSize: '0.9rem',
          color: '#6b7280',
          textAlign: 'center',
          marginBottom: '3rem',
          fontStyle: 'italic'
        }}>
          Yürürlük Tarihi: 03 Ağustos 2025
        </div>

        <div style={{
          fontSize: '1rem',
          lineHeight: '1.8',
          color: '#374151'
        }}>
          <p style={{ marginBottom: '1.5rem' }}>
            Bu Kullanıcı Sözleşmesi ("Sözleşme"), https://kostümakademi.com.tr web sitesi ve kostüm kiralama hizmetlerini kullanan tüm müşteriler ("Kullanıcı", "Kiracı") ile Kostüm Akademi ("Şirket", "Biz") arasında akdedilmiştir.
          </p>

          <p style={{ marginBottom: '2rem' }}>
            Web sitemizi kullanarak ve kostüm kiralama hizmetimizden yararlanarak bu sözleşme şartlarını kabul etmiş sayılırsınız.
          </p>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            1. HİZMET TANIMI
          </h2>

          <p style={{ marginBottom: '1rem' }}>
            <strong>1.1.</strong> Kostüm Akademi, kostüm kiralama ve danışmanlık hizmetleri sunmaktadır.
          </p>

          <p style={{ marginBottom: '1rem' }}>
            <strong>1.2.</strong> Hizmetlerimiz bilgilendirme amaçlı olup, online ödeme sistemi bulunmamaktadır.
          </p>

          <p style={{ marginBottom: '2rem' }}>
            <strong>1.3.</strong> Tüm rezervasyon ve ödemeler telefon, e-posta ile devam eder.
          </p>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            2. KİRALAMA ŞARTLARI
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            2.1. Rezervasyon Süreci
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Kostüm rezervasyonları telefon (iletişim bilgilerimizde belirtilen) veya e-posta ile yapılır</li>
            <li style={{ marginBottom: '0.5rem' }}>Rezervasyon için kimlik bilgileri gereklidir</li>
            <li style={{ marginBottom: '0.5rem' }}>Kostüm müsaitliği rezervasyon sırasında teyit edilir</li>
            <li style={{ marginBottom: '0.5rem' }}>2 gün için rezervasyon yapılır. 2 gün içinde kiralanmayan kostümün rezervasyonu iptal edilir.</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            2.2. Kiralama Süreleri
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}><strong>Standart kiralama süresi:</strong> 1-3 gün</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Uzun süreli kiralamamız yoktur.</strong></li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Kiralamanın başlangıcı:</strong> Kostümün teslim alındığı tarih</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>İade tarihi:</strong> Belirlenen son gün saat 18:00'e kadardır</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            2.3. Gecikme Durumu
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Geç iade durumunda <strong>günlük kira bedelinin %50'si</strong> ek ücret alınır</li>
            <li style={{ marginBottom: '0.5rem' }}>3 günden fazla gecikme durumunda kostümün satış bedeli tahsil edilir</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            3. FİYATLANDIRMA VE ÖDEME
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            3.1. Fiyat Politikası
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Fiyatlar kostümün türü, kalitesi ve kiralama süresine göre belirlenir</li>
            <li style={{ marginBottom: '0.5rem' }}>Fiyat değişikliği açıkça haber verilmektedir</li>
            <li style={{ marginBottom: '0.5rem' }}>Rezervasyon sırasında belirtilen fiyat geçerlidir</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            3.2. Ödeme Şartları
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Ödemeler nakit veya havale ile yapılır</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Depozito:</strong> kostüm değerinin %100'ü kadar depozito alınır.</li>
            <li style={{ marginBottom: '0.5rem' }}>Depozito, kostüm hasarı olmayan iade değişimi geri ödenir</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            3.3. İptal Koşulları
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}><strong>24 saat öncesi iptal:</strong> Ücretsiz</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>24 saat sonra iptal:</strong> Para yatırma işlemi yapılmaz</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Aynı gün iptal:</strong> Kira bedelinin tamamı tahsil edilir</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            4. KULLANICI SORUMLULUKLARI
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            4.1. Kostüm Bakımı
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Kostümler özenle kullanılmalı ve korunmalıdır</li>
            <li style={{ marginBottom: '0.5rem' }}>Yiyecek-içecek lekeleri, parfüm, deodorant sıkılması yasaktır</li>
            <li style={{ marginBottom: '0.5rem' }}>Sigara, alkol ortamında dikkatli kullanım şarttır</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            4.2. Hasar Durumu
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}><strong>Küçük lekeler:</strong> Profesyonel temizlik ücreti</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Büyük hasarlar:</strong> Kostüm değerinin %80 ücreti</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Tamir edilemez hasar:</strong> Kostümün tam satış bedeli</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Kayıp/çalınma:</strong> Kostümün tam bedeli + %20 ek ücret</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            4.3. Kullanım Kuralları
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Kostümler sadece belirtilen amaç için kullanılmalıdır.</li>
            <li style={{ marginBottom: '0.5rem' }}>Üçüncü kişilere alt kiralama yasaktır.</li>
            <li style={{ marginBottom: '0.5rem' }}>Kostümün orijinalinin değiştirilmesi, kesilmesi yasaktır.</li>
            <li style={{ marginBottom: '0.5rem' }}>Uygunsuz (müstehcen, alkollü) ortamlarda uzun süre kullanım yasaktır</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            5. ŞİRKET SORUMLULUKLARI
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            5.1. Hizmet Kalitesi
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Kostümler temiz ve kullanılabilir durumda teslim edilir</li>
            <li style={{ marginBottom: '0.5rem' }}>Kostüm uygunluğu konusunda danışmanlık verilir</li>
            <li style={{ marginBottom: '0.5rem' }}>Teknik sorunlar için destek sağlanır</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            5.2. Sorumluluk Sınırları
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Kostüm kullanımından doğan kişisel zararlardan sorumlu değiliz</li>
            <li style={{ marginBottom: '0.5rem' }}>Kostümün etkinlik öncesi bozulması durumunda alternatif kostüm sağlanır</li>
            <li style={{ marginBottom: '0.5rem' }}>Mücbir sebepler (doğal afet, pandemi vb.) durumunda sorumluluk kabul edilmez</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            6. FİKRİ MÜLKİYET HAKLARI
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            6.1. Telif Hakları
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Web sitesi içeriği (fotoğraf, metin, tasarım) Kostüm Akademi'ye aittir</li>
            <li style={{ marginBottom: '0.5rem' }}>İzinsiz kopyalama, çoğaltma yasaktır</li>
            <li style={{ marginBottom: '0.5rem' }}>Kostüm fotoğrafları tanıtım amaçlı kullanılabilir</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            6.2. Marka Koruması
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>"Kostüm Akademi" markası korunmaktadır</li>
            <li style={{ marginBottom: '0.5rem' }}>Yetkisiz kullanım yasal takibe tabidir</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            7. KİŞİSEL VERİLERİN KORUNMASI
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            7.1. KVKK Uyumu
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Kişisel verileriniz KVKK'ya uygun işlenir</li>
            <li style={{ marginBottom: '0.5rem' }}>Detaylar için "Gizlilik Politikası"nı inceleyiniz</li>
            <li style={{ marginBottom: '0.5rem' }}>Verileriniz üçüncü kişilerle paylaşılmaz</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            8. UYUŞMAZLIK ÇÖZÜMÜ
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            8.1. Yetkili Mahkeme
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Antalya Mahkemeleri yetkilidir</li>
            <li style={{ marginBottom: '0.5rem' }}>Türkiye Cumhuriyeti kanunları uygulanır</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            8.2. Alternatif Çözüm
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Sorunlar öncelikle müzakere ile çözülmeye çalışılır</li>
            <li style={{ marginBottom: '0.5rem' }}>Tüketici hakem heyetine başvuru mümkündür</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            9. DEĞİŞİKLİK VE GÜNCELLEMELER
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            9.1. Sözleşme Değişiklikleri
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Bu sözleşme önceden haber verilerek değiştirilebilir</li>
            <li style={{ marginBottom: '0.5rem' }}>Değişiklikler web sitesinde yayınlanır</li>
            <li style={{ marginBottom: '0.5rem' }}>Hizmet kullanımı değişiklikleri kabul anlamına gelir</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            10. İLETİŞİM BİLGİLERİ
          </h2>

          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '1.5rem'
          }}>
            <h3 style={{
              fontSize: '1.2rem',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '1rem'
            }}>
              Kostüm Akademi
            </h3>
            
            <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <strong>Adres:</strong> -
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <strong>E-posta:</strong> pentafemgiyim@gmail.com
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <strong>Email:</strong> info@kostumakademi.com
              </li>
            </ul>
          </div>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            Müşteri Şikayetleri
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}><strong>E-posta:</strong> pentafemgiyim@gmail.com</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Çalışma Saatleri:</strong> Pazartesi-Cumartesi 09:00-18:00</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Şikayet çözüm süresi:</strong> En geç 7 iş günü</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            11. ÖZEL DURUMLAR
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            11.1. Düğün ve Özel Etkinlikler
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Düğün kostümleri için özel fiyatlandırma uygulanır</li>
            <li style={{ marginBottom: '0.5rem' }}>Grup kiralama indirimleri mevcuttur</li>

          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            11.2. Çocuk Kostümleri
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>12 yaş altı çocuklar için veli onayı gereklidir</li>
            <li style={{ marginBottom: '0.5rem' }}>Çocuk kostümlerinde ekstra dikkat şarttır</li>
            <li style={{ marginBottom: '0.5rem' }}>Güvenlik öncelikli kostümler tercih edilir</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '1.5rem',
            marginTop: '2rem',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: '0.9rem',
              color: '#6b7280',
              marginBottom: '1rem'
            }}>
              <strong>Son Güncelleme:</strong> 03 Ağustos 2025
            </p>

            <p style={{
              fontSize: '1rem',
              color: '#374151',
              marginBottom: '1rem',
              textAlign: 'center'
            }}>
              Bu sözleşmenin koşullarını yapılandırdığınızı ve onayladığınızı kabul etmiş sayılırsınız. Hizmetlerimizi kullanarak bu şartları kabul etmiş olursunuz.
            </p>

          
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms; 